import {
  getCareTypes,
  getCareTypeById,
  getCareTypeByCode,
  createCareTypes,
  updateCareType,
  deleteCareType,
} from "../webclients/care-types.client";
import type { CareType } from "../webclients/care-types.client";

export const careTypeApi = {
  getCareTypes: async (lang: string): Promise<CareType[]> => {
    const response = await getCareTypes(lang);
    return response.data;
  },
  getCareTypeById: async (id: number): Promise<CareType> => {
    const response = await getCareTypeById(id);
    return response.data;
  },
  getCareTypeByCode: async (code: string): Promise<CareType> => {
    const response = await getCareTypeByCode(code);
    return response.data;
  },
  createCareTypes: async (careTypes: CareType[]): Promise<CareType[]> => {
    const response = await createCareTypes(careTypes);
    return response.data;
  },
  updateCareType: async (id: number, careType: CareType): Promise<CareType> => {
    const response = await updateCareType(id, careType);
    return response.data;
  },
  deleteCareType: async (id: number): Promise<void> => {
    await deleteCareType(id);
  },
};

export default careTypeApi;

